import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../Visuals/Icons/CloseIcon.icon';
import { CourseDetailsContainer } from '../../CompanyRoutes/PurchasedCourses/TrainingList.styles';
// import SendReminderEmailButton from '../../AdminRoutes/EditRoutes/EditUser/UserCoursesPage/SendReminder/SendReminderEmail';

// I moved this somewhere else, thought it was the right one, make sure to change it back
// userId, courseId, there are also coming in within the params
const CourseInfoForUser = ({ user, course }) => {
  if (!course) return null;
  const [status, setStatus] = useState('empty');
  const [close, setClose] = useState(false);
  const handleClose = () => {
    setClose(true);
    console.log(close);

    // setCourseSelected(null);
  };
  // console.log(user, userId, courseId, course, close);
  useEffect(() => {
    if (course) {
      if (new Date(course.expiryDate) < new Date()) {
        setStatus('expired');
      } else if (!course.complete) {
        setStatus('in-progress');
      } else {
        setStatus('completed');
      }
    }
  }, [user, course]);

  const sideBySide = {
    display: 'flex',
    gap: '1rem',
  };
  return (
    <CourseDetailsContainer status={status}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h3>{`${user.firstName} ${user.lastName} - ${course.courseName}`}</h3>
        <CloseIcon functionName={handleClose} />
      </div>
      <dl>
        <div style={sideBySide}>
          <dt>User Type:</dt>
          <dd>{user?.type === 'User' ? 'Employee' : 'Manager'}</dd>
        </div>
        <div style={sideBySide}>
          <dt>Course Name:</dt>
          <dd>{course.courseName}</dd>
        </div>
        <div style={sideBySide}>
          <dt>Status:</dt>
          <dd>
            {course.complete
              ? 'Course has been completed'
              : 'Course is in progress'}
          </dd>
        </div>
        {course.certNum && (
          <div style={sideBySide}>
            <dt>Certificate Number:</dt>
            <dd>{course.certNum}</dd>
          </div>
        )}

        {course.date && (
          <div style={sideBySide}>
            <dt>Date Completed:</dt>
            <dd>{course.date}</dd>
          </div>
        )}

        {course.score > 0 && (
          <div style={sideBySide}>
            <dt>Score:</dt>
            <dd>{course.score}</dd>
          </div>
        )}

        {course.purchaseDate && (
          <div style={sideBySide}>
            <dt>Purchase Date:</dt>
            <dd>{course.purchaseDate.toLocaleString()}</dd>
          </div>
        )}

        {course.expiryDateLong && (
          <div style={sideBySide}>
            <dt>Expiry Date:</dt>
            <dd>{course.expiryDateLong}</dd>
          </div>
        )}
      </dl>
      {/* {!course.complete && (
        <SendReminderEmailButton userId={user._id} courseId={course._id} />
      )} */}
    </CourseDetailsContainer>
  );
};

CourseInfoForUser.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.string,
  courseId: PropTypes.string,
  course: PropTypes.object,
};

export default CourseInfoForUser;
